import { DsplNode } from '../vm/interface'
import { KeyedCache } from 'everyday-utils'
import { queue, reactive } from 'minimal-view'
import { FFT_BLOCK_SIZE, SAMPLE_SECONDS } from './constants'
import { IS_FIREFOX } from './env'
import { PFFT, createRunner } from 'pretty-fast-fft'

export type Audio = typeof Audio.State

export const Audio = reactive('audio',
  class props {
  },
  class local {
    context?: AudioContext
    analyser?: PFFT
    isPlaying = false
    dspl?: DsplNode
    gain?: GainNode
    vol = 0.5
    bpm = 144
    totalTime = 1
    rmsSum = 0
  },
  function actions({ $, fn, fns }) {
    return fns(new class actions {
      createContext = () => {
        if (!$.context) {
          $.context = new AudioContext({ sampleRate: 44100, latencyHint: 0.00001 })
          $.context.resume()
        }
      }

      start = () => {
        if ($.isPlaying) {
          this.reset()
          return
        }

        if ($.context!.state !== 'running') {
          $.context!.resume()
          const iv = setInterval(() => {
            if ($.context!.state === 'running') {
              $.isPlaying = true
              clearInterval(iv)
            }
          }, 100)
        }
        else {
          $.isPlaying = true
        }
      }

      stop = () => {
        if (!$.isPlaying) {
          this.reset()
          return
        }
        $.isPlaying = false
      }

      reset = () => {
        $.dspl?.reset()
      }

      fetchSample = KeyedCache(
        queue.atomic.concurrency(2)(async (sampleId: number) => {
          const { context } = $

          const url = `https://freesound.cowbell.lol/get?id=${sampleId}`

          // console.time('fetch')
          const arrayBuffer = await (await fetch(url)).arrayBuffer()
          // console.timeEnd('fetch')

          // console.time('decode')
          const audioBuffer = await context!.decodeAudioData(arrayBuffer)
          // console.timeEnd('decode')

          // console.time('copy')
          const channelsFloats = [] as Float32Array[]
          for (let c = 0; c < Math.min(2, audioBuffer.numberOfChannels); c++) {
            const buffer = audioBuffer.getChannelData(c)
            const length = Math.min(buffer.length, SAMPLE_SECONDS * audioBuffer.sampleRate)
            const sharedArrayBuffer = new SharedArrayBuffer(
              length * Float32Array.BYTES_PER_ELEMENT
            )
            const floats = new Float32Array(sharedArrayBuffer)
            floats.set(buffer.subarray(0, length))
            channelsFloats.push(floats)
          }
          // console.timeEnd('copy')

          return { audioBuffer, channelsFloats }
        })
      )
    })
  },
  function effects({ $, fx, deps }) {
    if (!IS_FIREFOX) $.createContext()

    fx(async () => {
      $.analyser = await createRunner(FFT_BLOCK_SIZE)
    })

    fx(({ context }) => {
      $.gain = context.createGain()
      $.gain.connect(context.destination)
    })

    fx(async ({ context }) => {
      $.dspl = await DsplNode.create(context)
      $.dspl.fetchSample = async (sampleId: number) => {
        const result = await $.fetchSample(sampleId)
        return result.channelsFloats
      }
      // setTimeout($.start, 1500)
    })

    fx(({ dspl, isPlaying }) => {
      if (isPlaying) {
        dspl.start()
      }
      else {
        dspl.stop()
      }
    })

    // fx(({ graph, bpm }) => {
    //   graph.clock.setBpm(bpm)
    // })

    // fx(({ graph, seqMode }) => {
    //   graph.clock.seqMode = seqMode
    // })

    fx(({ gain, dspl }) => {
      dspl.connect(gain)
    })

    fx(({ vol, gain }) => {
      gain.gain.setTargetAtTime(vol, gain.context.currentTime, 0.0015)
    })
  }
)

export const audio = Audio({})
